import { COMMON_DASHBOARD_TABS } from "../actions/constants";
import { DASHBOARD_COMMON } from "../actions/types";
import _ from "lodash";

const initialState = {
  error: null,
  isLoading: false,
  workspaces: [],
  openTutorials: true,
  showTestsAsGrid: true,
  activeWorkspace: null,
  leftMenuData: null,
  activeTab: COMMON_DASHBOARD_TABS.TEAMS_DASHBOARD,
  activeTeam: null,
  activeProject: null,
};

// Prevent unnecessary state updates by checking the new state with the old state
const updateState = (state, payload) => {
  const newState = { ...state, isLoading: false };
  Object.keys(payload).forEach((key) => {
    if (!_.isEqual(state[key], payload[key])) {
      newState[key] = payload[key];
    }
  });
  return newState;
};

export default function dashboardCommonReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case DASHBOARD_COMMON.LOAD:
      return { ...state, isLoading: true, ...payload };

    case DASHBOARD_COMMON.UPDATE:
      return updateState(state, payload);

    case DASHBOARD_COMMON.RESET:
      return initialState;

    case DASHBOARD_COMMON.ERROR:
      return { ...state, isLoading: false, error: payload };

    default:
      return state;
  }
}
